import React from "react";

import styles from "./CritterTile.module.css";
import TimeBar from "./TimeBar";
import CheckMarkIcon from "./CheckMarkIcon";
import TimeAndSeasonGraph from "./TimeAndSeasonGraph";
import Info from "./Info";

const inRange = (range, now) => {
  const hour = now.getHours() + now.getMinutes() / 60;
  if (range[0] <= hour && hour <= range[1]) {
    return true;
  }
  if (range[2] <= hour && hour <= range[3]) {
    return true;
  }
  return false;
};

const check = (fish, hemisphere, now, mode) => {
  switch (mode) {
    case 0:
      return inRange(fish.time, now);
    case 1:
      return !fish.season[hemisphere][now.getMonth() + 1];
    case 2:
      return (
        fish.season[hemisphere][now.getMonth()] &&
        !fish.season[hemisphere][now.getMonth() - 1]
      );
    default:
      return false;
  }
};

const CritterTile = ({
  critter,
  hemisphere,
  isComplete,
  now,
  mode,
  onClick,
  lastRow,
  lastCol,
}) => {
  const currentMonth = now.getMonth();

  const notInSeason = !critter.season[hemisphere][currentMonth];
  const dim = isComplete || notInSeason;

  let itemStyle = isComplete || notInSeason ? styles.dim : styles.item;
  if (lastRow) {
    itemStyle += " " + styles.lastRow;
  }
  if (lastCol) {
    itemStyle += " " + styles.lastCol;
  }

  return (
    <div className={itemStyle} onClick={() => onClick()}>
      <TimeAndSeasonGraph critter={critter} hemisphere={hemisphere} now={now} />

      <Info critter={critter} />

      {!dim && check(critter, hemisphere, now, mode) && (
        <div className={styles.highlight} />
      )}

      <img
        alt={critter.name}
        className={styles.image}
        src={process.env.PUBLIC_URL + critter.image}
      />

      {isComplete && <CheckMarkIcon />}

      <TimeBar start={critter.time[0]} end={critter.time[1]} />
      <TimeBar start={critter.time[2]} end={critter.time[3]} />

      <div className={styles.jan}>Jan</div>
      <div className={styles.dec}>Dec</div>
      <div className={styles.am}>12 AM</div>
      <div className={styles.pm}>12 PM</div>
    </div>
  );
};

export default CritterTile;
